/* eslint-disable wrap-iife */
/* eslint-disable prefer-rest-params */
/* eslint-disable prefer-const */
import { useEffect } from 'react';
const { __DEV__ } = process.env;

const useInjectPendo = () => {
    useEffect(() => {
        if (__DEV__) return;
        (function (apiKey) {
            (function (p, e, n, d, o) {
                let w, x, y, z;
                o = p[d] = p[d] || {};
                o._q = [];
                const v = [
                    'initialize',
                    'identify',
                    'updateOptions',
                    'pageLoad',
                ];
                for (w = 0, x = v.length; w < x; ++w)
                    (function (m) {
                        o[m] =
                            o[m] ||
                            function () {
                                o._q[m === v[0] ? 'unshift' : 'push'](
                                    [m].concat([].slice.call(arguments, 0)),
                                );
                            };
                    })(v[w]);
                y = e.createElement(n);
                y.async = !0;
                y.src =
                    'https://cdn.pendo.io/agent/static/' + apiKey + '/pendo.js';
                z = e.getElementsByTagName(n)[0];
                z.parentNode.insertBefore(y, z);
            })(window, document, 'script', 'pendo');
        })('a821ced5-6c70-4f62-48e7-be04cf3731e4');
    }, []);
};

export default useInjectPendo;
